import { render } from "./EmailApplicationModal.vue?vue&type=template&id=20cf487a"
import script from "./EmailApplicationModal.vue?vue&type=script&lang=js"
export * from "./EmailApplicationModal.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__